'use client';
import { getCTA } from '@/utils/getCTA';
import { getColorScheme } from '@/utils/getColorScheme';
import { isGradientColorScheme } from '@/utils/gradientDirection';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';

export default function ReviewPage(props) {
    const {
        CTA,
        SecondaryButtonText,
        OutlineButtonText,
        ColorScheme = 'light',
        GradientDirection = 'down',
        VerticalSpacing = 'medium',
    } = props;
    const { backgroundColor, thirdButton, secondaryButton, backgroundStyle } =
        getColorScheme(ColorScheme, GradientDirection);

    const vSpace = getVerticalSpacing(VerticalSpacing);
    const { hasAny: hasCTAs, element: CTAs } = getCTA(props, {
        secondaryVariant: secondaryButton,
        outlineVariant: thirdButton,
        wrapSpacing: 'mt-0',
        buttonAlign: 'justify-center',
        buttonsClassName: 'flex flex-wrap items-center justify-center gap-4',
        className: '',
        size: 'md',
    });

    return (
        <div
            className={`editable-component relative ${backgroundColor} ${vSpace}`}
            style={
                isGradientColorScheme(ColorScheme) ? backgroundStyle : undefined
            }
        >
            <div className="relative z-40 mx-auto max-w-7xl px-6 lg:px-8">
                {/*WorkStories*/}
                <div className="flow-root">
                    <div
                        className="nj-stories"
                        data-filter-media="show"
                        data-branding="bottom"
                    ></div>

                    {/* CTA */}
                    <div className="flex w-full justify-center">
                        {(CTA || SecondaryButtonText || OutlineButtonText) && (
                            <div className="relative z-40 mt-10 flex max-w-4xl flex-wrap items-center justify-center gap-4 lg:mt-16">
                                {hasCTAs && CTAs}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
